import React from "react";
import { BsPlusLg } from "react-icons/bs";

const ImageCard = ({ imageData, setModal }) => {
  const { title, data, subTitle, bgImage, img } = imageData;
  return (
    <>
      <div>
        <div className=" group relative cursor-pointer items-center justify-center overflow-hidden transition-shadow hover:shadow-xl hover:shadow-black/30">
          <img
            src={bgImage}
            alt=""
            className={`images h-full  w-full object-cover  transition-transform duration-500 group-hover:rotate-3 group-hover:scale-125`}
          />
          <div class="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/70 group-hover:via-black/60 group-hover:to-black/70">
            <h1 class="font-serif text-xl text-center mt-[200px]  font-bold text-white">
              {title}
            </h1>
            <p class="mb-3 text-center mt-[7px] italic text-gray-300 ">
              {subTitle}
            </p>
          </div>

          <div class="absolute inset-0 flex  flex-col items-center justify-center px-9 text-center transition-all duration-500 group-hover:translate-y-0">
            <label
              htmlFor="my-modal-3"
              onClick={() => setModal({ data, img, title })}
              className="font-serif text-xl font-bold text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100"
            >
              <BsPlusLg className="text-3xl text-white" />
            </label>
          </div>
        </div>
      </div>
    </>
  );
};
export default ImageCard;
